import styled from "styled-components";

export const StyledHeadText = styled.h5`
    width: 150px; 
`

export const StyledText = styled.div`
    align-item: center;
    width: 300px;
    display: flex;
    flex-wrap: wrap;
    margin: 0 2px;
    & > span {
        margin-right: 2px;
    }
`

export const StyledEventText = styled.div`
    width: 150px;
    display: flex;
    margin: 0 2px;
    & > span {
        margin-right: 2px;
    }
`

export const StyledContainer = styled.div`
    width: 300px;
    margin: 10px auto;
    text-align: center;
`

export const StyledSubmit = styled.button`
    padding: 12px;
    font-size: 18px;
    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    background-image: linear-gradient(-180deg, #37AEE2 0%, #1E96C8 100%);
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
        background-image: linear-gradient(-180deg, #1D95C9 0%, #17759C 100%);
    }

`